export const SESSION_STORAGE_QUERY_PARAMS_KEY = 'bgo.queryParams'
export const VOUCHER_QUERY_PARAM = 'voucher'
